import { useModelTypeQuery } from './ModelTypeQuery.generated';
import { sendErrorEvent } from '@trello/error-reporting';

export const useOrgIdFromModel = (name: string): string => {
  const { data, error } = useModelTypeQuery({
    variables: { name },
    skip: !name,
  });

  if (error)
    sendErrorEvent(error, {
      tags: { ownershipArea: 'trello-nusku' },
    });

  return data?.modelType?.type === 'organization' ? data.modelType.id : '';
};
